import { Message } from 'element-ui';
import axios from 'axios';
import { responseError } from './utilRequest';
import { HTTP_METHODS, RESPONSE_BUSINESS_CODES, RESPONSE_CODES, RESPONSE_ERROR_CODES } from '../constants';
const serializeData = (data) => {
    const searchParams = new URLSearchParams();
    Object.entries(data !== null && data !== void 0 ? data : {}).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return;
        }
        searchParams.append(key, String(value));
    });
    return searchParams.toString();
};
export const createRequestClient = ({ getAuthHeaders, baseHeader = {}, defaultRewriteHost = '', withCredentials = false } = {}) => {
    /** 获取 rewriteHost，支持字符串或函数形式 */
    const getDefaultRewriteHost = () => typeof defaultRewriteHost === 'function' ? defaultRewriteHost() : defaultRewriteHost;
    const request = ({ url = '', data = {}, method = HTTP_METHODS.GET, options = {}, headers = {}, rewriteHost, showFailedErrorMsg = true, showSuccessMsg = false, responseAll = false }) => {
        var _a;
        const finalRewriteHost = rewriteHost !== null && rewriteHost !== void 0 ? rewriteHost : getDefaultRewriteHost();
        const authHeaders = (_a = getAuthHeaders === null || getAuthHeaders === void 0 ? void 0 : getAuthHeaders()) !== null && _a !== void 0 ? _a : {};
        const axiosOptions = Object.assign({ url: finalRewriteHost ? `${finalRewriteHost}${url}` : url, method, headers: Object.assign(Object.assign(Object.assign({}, baseHeader), headers), authHeaders), withCredentials }, options);
        if (method.toLowerCase() === HTTP_METHODS.GET) {
            const queryString = serializeData(data);
            axiosOptions.url = queryString ? `${axiosOptions.url}?${queryString}` : axiosOptions.url;
        }
        else {
            axiosOptions.data = data;
        }
        if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            axiosOptions.data = serializeData(data);
        }
        if (headers['Content-Type'] === 'multipart/form-data') {
            const formData = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                formData.append(key, value);
            });
            axiosOptions.data = formData;
        }
        return axios(axiosOptions)
            .then(res => {
            if (res.status === RESPONSE_CODES.HTTP_SUCCESS) {
                if (res.data.response.code === RESPONSE_BUSINESS_CODES.CODE) {
                    if (showSuccessMsg) {
                        Message.success(res.data.response.describe || '操作成功');
                    }
                    return responseAll ? res.data : res.data.data;
                }
                return Promise.reject(res.data);
            }
            return Promise.reject(res.data);
        })
            .catch(err => {
            if (Object.values(RESPONSE_ERROR_CODES).includes(err.code)) {
                // Keep logout/session-expired handling in app layer.
            }
            if (showFailedErrorMsg) {
                responseError(err);
            }
            return Promise.reject(err);
        });
    };
    return {
        request,
        get: (config) => request(Object.assign({ method: HTTP_METHODS.GET }, config)),
        post: (config) => request(Object.assign({ method: HTTP_METHODS.POST }, config)),
        put: (config) => request(Object.assign({ method: HTTP_METHODS.PUT }, config)),
        del: (config) => request(Object.assign({ method: HTTP_METHODS.DEL }, config))
    };
};
